// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__rHAbH","waypoint":"style_waypoint__V5lJA"};